<template>
    <component
        :is="areMarketsShownOutside ? 'portal' : 'div'"
        to="markets-sidebar"
    >
        <div
            class="event-row__expanded-markets"
        >
            <template v-if="markets.length">
                <transition-group name="animation-list__market-group-">
                    <div
                        v-for="market in markets"
                        :key="market.uniqueId"
                        class="event-row__expanded-market-group"
                    >
                        <div :class="`market-${market.id}`">
                            <div class="event-row__expanded-market-header">
                                <span class="event-row__expanded-market-title">
                                    {{ market.name }}
                                </span>
                                <div class="event-row__expanded-market-actions">
                                    <i
                                        @click="toggleDescription(market.id)"
                                        :title="$t('bets info') | capitalize"
                                        class="icon--sm event-row__expanded-market-icon icon-info_circle mr-2"
                                    />
                                    <i
                                        v-if="isFavouritable && !market.isMain && !market.isPromotion"
                                        @click.stop="$emit('favouriteMarketClick', market.id)"
                                        class="icon--md event-row__expanded-market-icon icon-favourite"
                                        :class="{'icon-favourite_filled': isFavouriteMarket(market)}"
                                    ></i>
                                </div>
                            </div>
                            <div
                                :class="{ 'is-locked': isEventLocked || market.isLocked }"
                                class="event-row__expanded-markets-container"
                            >
                                <div
                                    v-for="[groupName, odds] in marketGroups(market.odds)"
                                    :key="groupName"
                                    class="event-row__expanded-market-type-group"
                                >
                                    <Pick
                                        v-for="odd in odds"
                                        :key="odd.uniqueId || odd.id"
                                        v-bind="odd"
                                        :eventId="eventId"
                                        :tooltipDescription="odd.description"
                                        :isEventLocked="isEventLocked"
                                        :valueChangeDynamics="oddValueDynamics && oddValueDynamics[odd.uniqueId]"
                                        :specialBetValue="isOngoing ? '' : odd.specialBetValue"
                                        :class="selectedOdd === `${odd.id}-${odd.specialBetValue}` ? 'is-selected' : ''"
                                        @click="$emit('oddClick', odd)"
                                    />
                                </div>
                            </div>
                            <div class="event-row__odd-descriptions">
                                <transition
                                    v-if="openDescriptions[market.id]"
                                    mode="out-in"
                                    name="animation__odd-description-"
                                >
                                    <div
                                        class="event-row__odd-descriptions-box"
                                    >
                                        <div
                                            v-for="([groupName, odds]) in marketGroups(market.odds)"
                                            :key="groupName"
                                        >
                                            <div
                                                v-for="odd in odds"
                                                :key="odd.uniqueId"
                                                class="event-row__odd-description"
                                            >
                                                <strong>{{odd.symbol }}</strong> - {{ odd.description }}
                                            </div>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div>
                </transition-group>
            </template>
            <div
                v-else
                class="primary-market__unavalibale px-3"
            >
                {{ $t('no markets currently available') | upperCase }}
            </div>
        </div>
    </component>
</template>

<script>
    import oddComparator from '@core/utils/sortComparators/oddComparator';
    import Pick from '@modules/shared/event/Pick.vue';
    import groupBy from '@core/utils/dataTransformation/groupBy';

    export default {
        name: 'Markets',
        data() {
            return {
                openDescriptions: {}
            };
        },
        props: {
            markets: {
                type: Array,
                required: true,
            },
            isFavouritable: {
                type: Boolean,
                required: true,
            },
            eventId: {
                type: Number,
                required: true,
            },
            isFavouriteMarket: {
                type: Function,
                required: true,
            },
            selectedOdd: {
                type: String,
                required: false,
            },
            isEventLocked: {
                type: Boolean,
                required: true
            },
            oddValueDynamics: {
                type: Object,
                required: false,
            },
            isOngoing: {
                type: Boolean,
                required: false,
                default: false,
            },
            areMarketsShownOutside: {
                type: Boolean,
                required: true,
            },
        },
        methods: {
            marketGroups(odds) {
                const sortedOdds = odds.sort(oddComparator);
                const groupedOdds = groupBy(sortedOdds, 'specialBetValue');
                return Array.from(groupedOdds);
            },
            async toggleDescription(marketId) {
                if (this.openDescriptions[marketId]) {
                    this.$delete(this.openDescriptions, marketId);
                } else {
                    this.$set(this.openDescriptions, marketId, true);
                }
                // next tick is needed so the actual height change is rendered
                await this.$nextTick();
                this.$emit('marketHeightChange');
            }
        },
        components: {
            Pick
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/eventGrid/components/AllMarkets.vue